<template>
  <div id="app">
    <div class = "home-section">
      <div class = "introduction">
        <h1 class = "name"> I'm Andrew Wu </h1>
        <p> A programmer from NTU CSIE and has been studying CS <strong> over 6 years. </strong></p>
        <p> A passionate programmer always trying to improve our lives with <strong>technology</strong></p>
        <h2> Contact me:</h2>
        <a href="https://github.com/wuddder" target = "_blank">
        <i class = "fa fa-github contact-icon" aria-hidden = "true"></i>
        </a>
        <a href="https://www.linkedin.com/in/yu-chian-wu-831a7013a/" target = "_blank">
        <i class = "fa fa-linkedin-square contact-icon" aria-hidden = "true"></i>
        </a>
        <a href="https://www.facebook.com/wu.qi.5" target = "_blank">
        <i class = "fa fa-facebook contact-icon" aria-hidden = "true"></i>
        </a>
        <a href="andrew90622@gmail.com" target = "_blank">
        <i class = "fa fa-envelope contact-icon" aria-hidden = "true"></i>
        </a>
      </div>
    </div>
    <div class = "whitebg-section">
      <div class = "section-content">
        <div class = "title">
          <h1> About </h1>
          <img  class = "profile-picture" src = "static/profilepic.png" width="100px">
        </div>
        <div class = "content">
          <h2>Yuh-Chian, Wu</h2>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lectus arcu bibendum at varius. Amet tellus cras adipiscing enim eu turpis egestas. Orci porta non pulvinar neque laoreet suspendisse interdum consectetur. Nibh praesent tristique magna sit.</p>
        </div>
      </div>
    </div>
    <div class = "bluebg-section">
      <div class = "section-content">
        <div class = "title">
          <h1> Education </h1>
          <img src = "static/mortarboard.png" width="60px">
        </div>
        <div class = "content">
          <div class = "box" v-for="item in eduaction">
            <h2> {{item.school}} </h2>
            <div class = "small"> {{item.year}} </div>
            <p> {{item.degree}} </p>
          </div>
        </div>
      </div>
    </div>
    <div class = "whitebg-section">
      <div class = "section-content">
        <div class = "title">
          <h1>Skills</h1>
          <img src = "static/skills.png" width="60px">
        </div>
        <div class = "content">
          <div class = "box" v-for="item in skills">
            <img :src = "item.image" width="20px">
            <h2> {{item.skill_name}} </h2>
            <div class = "small"></div>
            <p> {{item.skills}} </p>
          </div>
        </div>
      </div>
    </div>
    <div class = "bluebg-section">
      <div class = "section-content">
        <div class = "title">
          <h1>Publication</h1>
          <img src="static//publication.png" width="60px">
        </div>
        <div class = "content">
          <div class = "projectbox" v-for="item in publication" @click="getProjectInformation(item)">
            <img :src="item.image" width = "100%">
            <div class = "project-title"> {{item.title}} </div>
            <div class = "project-subtitle"> {{item.subtitle}} </div>
            <div class = "small"> {{item.conference}} </div>
            <div class = "tagg" v-for = "tech in item.tech"> {{tech}} </div>
          </div>
        </div>
      </div>
    </div>
    <div class = "whitebg-section">
      <div class = "section-content">
        <div class = "title">
          <h1>Projects</h1>
        </div>
        <div class = "content">
          <div class = "projectbox" v-for = "item in project" @click = "getProjectInformation(item)">
            <img :src="item.image">
            <div class = "project-title"> {{item.title}} </div>
            <div class = "tagg" v-for = "tech in item.tech"> {{tech}} </div>
          </div>
        </div>
      </div>
    </div>
    <div class = "modal" :class = "cubeshow">
      <div class = "modal-background" @click = "endShow()">
      </div>
      <div class = "modal-card">
        <div class = "modal-card-head">
          <div class = "content">
            <h2> {{cube.title}} </h2>
            <p> {{cube.subtitle}} </p>
          </div>
        </div>
        <div class = "modal-card-body">
          <div class = "content">
            <h2> Introduction </h2>
            <ol>
              <li v-for = "intro in cube.abstract"> {{intro}} </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DetailCube from '@/components/DetailCube'
export default {
  name: 'app',
  components: {
    DetailCube
  },
  data () {
    return {
      cubeshow: '',
      cube: {
        title: 'heellllo',
        subtitle: 'hahaha',
        abstract: 'qqq',
        image: ''
      },
      eduaction: [
        {
          school: 'National Taiwan University',
          year: '2016 - present',
          degree: 'Master',
          lab: 'Mobile Device and Human Computer Interaction'
        },
        {
          school: 'National Taipei University',
          year: '2012 - 2016',
          degree: 'Bachelor'
        }
      ],
      skills:[
        { 
          image: 'static/file-code.png',
          skill_name: 'Programming Languages',
          skills: 'C/C++, Python, JavaScript, C#'
        },
        {
          image: 'static/grid-world.png',
          skill_name: 'Web-related',
          skills: 'PHP, HTML(pug), CSS(sass), Vue.js, Node.js'
        },
        {
          image: 'static/settings.png',
          skill_name: 'Tools',
          skills: 'Unity3D, Arduino, QT, Raspberry pi'
        },
      ],
      publication: [
        {
          image: 'static/ActiveErgo.png',
          title: 'ActiveErgo',
          subtitle: 'Automatic and Personalized Ergonomicsusing Self-actuating Furniture',
          conference: "CHI '18",
          tech: ['Untiy', 'C#', 'Arduino', 'Robotic Arm'],
          abstract: ['  Proper ergonomics improves productivity and reduces risks for injuries such as tendinosis, tension neck syndrome, and back injuries. Despite having ergonomics standards and guidelines for computer usage since the 1980s, injuries due to poor ergonomics remain widespread. We present ActiveErgo, the first active approach to improving ergonomics by combining sensing and actuation of motorized furniture. It provides automatic and personalized ergonomics of computer workspaces in accordance to the recommended ergonomics guidelines. Our prototype system uses a Microsoft Kinect sensor for skeletal sensing and monitoring to determine the ideal furniture positions for each user, then uses a combination of automatic adjustment and real-time feedback to adjust the computer monitor, desk, and chair positions. Results from our 12-person user study demonstrated that ActiveErgo significantly improves ergonomics compared to manual configuration in both speed and accuracy, and helps significantly more users to fully meet ergonomics guidelines.']
        },
        {
          image: 'static/Peritext.png',
          title: 'PeriText',
          subtitle: 'Utilizing Peripheral Vision for Reading Text onAugmented Reality Smart Glasses',
          conference: "VRST '18",
          tech: ['Untiy', 'C#', 'HTML', 'JavaScript', 'Hololens'],
          abstract: ['  Augmented Reality (AR) provides real-time information bysuperimposing virtual information onto users’ view of thereal world.  Our work is the first to explore how peripheralvision, instead of central vision, can be used to read text on ARand smart glasses. We present PeriText, a multiword readinginterface using rapid serial visual presentation (RSVP). Thisenables users to observe the real world using central vision,while using peripheral vision to read virtual information. Weconducted a lab-based study to compare reading efficiencyamong 6 different text transformation, 2 retinal eccentricities,and 3 different numbers of words for RSVP paradigm. We alsoconducted a field study to evaluate the information transferwhile using PeriText in a real-world walking scenario.']
        },
        {
          image: 'static/CircuitSense.png',
          title: 'CircuitSense',
          subtitle: 'Automatic Sensing of Physical Circuits and Generation of Virtual Circuits',
          conference: "UIST '17",
          tech: ['Machine Learning', 'C/C++', 'QT', 'Hardware Design'],
          abstract: ['  The rise of Maker communities and open-source electronic prototyping platforms have made electronic circuit projects increasingly popular around the world. Although there are soft-ware tools that support the debugging and sharing of circuits,they require users to manually create the virtual circuits in software, which can be time-consuming and error-prone. Wepresent CircuitSense, a system that automatically recognizes the wires and electronic components placed on breadboards. It uses a combination of passive sensing and active probing to detect and generate the corresponding circuit representation in software in real-time. CircuitSense bridges the gap between the physical and virtual representations of circuits. It enables circuits while gaining the benefits of using software tools. It also dramatically simplifies the sharing of circuit designs with online communities.']
        },
        {
          image: 'static/currentViz.png',
          title: 'CurrentViz',
          subtitle: 'Sensing and Visualizing Electric Current Flows of Breadboarded Circuits',
          conference: "UIST '17",
          tech: ['C/C++', 'QT', 'Hardware design'],
          abstract: ['  Electric current and voltage are fundamental to learning, understanding, and debugging circuits. Although both can be measured using tools such as multimeters and oscilloscopes, users have to unplug parts of a circuit and then insert the measuring tools in serial. Furthermore, users need to restore been taken. In practice, this cumber some process poses aformidable barrier to understanding how current flows through-out a circuit. We present CurrentViz, a system that can sense and visualize the electric current flowing through a circuit, which helps users quickly understand otherwise invisible circuit behavior. It supports fully automatic, ubiquitous, and real-time collection of amperage information of breadboarded circuits. It also supports visualization of the amperage data on a circuit schematic to provide an intuitive view into the current state of a circuit.']
        },
        {
          image: 'static/PartyAnimals.png',
          title: 'Party Animals',
          subtitle: 'Creating Immersive Gaming Experience for Physically Co-present VR and Non-VR Players',
          conference: "CHI '17",
          tech: ['Untiy', 'C#', 'VIVE', 'Kinect'],
          abstract: ['  With the rise of Virtual Reality, VR gaming in physically co- present social settings is becoming more important, and the interaction between the VR players and non-VR players pose an interesting game design challenge.Previous work have explored having non VR players using only controllers, resulting in limited immersion and overlooked co-presence cues. We designed and implemented Party An- imals, a VR party game that empowered non-VR users to interact through body gestures and also used physical co-presence cues in the gameplay. The results of our eval- uation showed that the immersion of non-VR players was indeed promoted. Party Animals explored new interaction between VR and non-VR players, and integrates physical co-presence cues with the virtual world gameplay.']
        }
      ],
      project: [
        {
          image: 'static/ntuelection.png',
          title: 'NTU principal election website',
          tech: ['PHP', 'Vue.js', 'HTML', 'CSS'],
          abstract: ['A website for the election of NTU principal', 'Developed frontend with Vue.js', 'Developed backend with PHP']
        },
        {
          image: 'static/roshambo.jpg',
          title: 'Roshambo',
          tech: ['Python', 'Raspberry pi', 'Machine Learning'],
          abstract: ['A system controls one hand with Electric Muscle Simulator(EMS) and recognize player’s gesture in realtime to be the opponent inRoshambo game.', 'Implemented the game with Python PyQT library.', 'Developed two devices to recognize gestures. One used Leap Motion to detect gestures, and the other used DIY IR camera with SVMgesture detection using raspberry pi']
        },
        {
          image: 'static/virus.jpg',
          title: 'Virus Fun Run',
          tech: ['Android', 'IOT', 'Design'],
          abstract: ['Enhanced night runner’s joyfulness through the light interaction between different Android devices by combination of IOIO Arduinoshield and Android App', '3rd Place of FAREASTONE IOT Development Competition']
        },
        {
          image: 'static/researchmap.png',
          title: 'Research Map',
          tech: ['Vue.js', 'Express.js', 'Python'],
          abstract: ['A website enables user to search the professors and the lab of each field in computer science', 'A project conducted with Vue.js and Express.js', 'Collected data from worldwide educational website']
        }
      ]
    }
  },
  methods: {
    getProjectInformation (item) {
      this.cube.title = item.title;
      if (item.subtitle)
        this.cube.subtitle = item.subtitle;
      this.cube.abstract = item.abstract;
      this.cube.image = item.image;
      this.cubeshow = 'is-active';
    },
    endShow() {
      this.cubeshow = '';
    }
  }
}
</script>

<style lang="sass">
@import "../node_modules/bulma/bulma.sass"
@media only screen and (max-width: 899px)
  .introduction
    padding: 10px 30px
    .name
      font-size: 40px
  .section-content
    padding: 60px 30px
    flex-direction: column 
    .title
      margin-bottom: 16px
      padding: 0px 5px
      width: 100%
    .content
      padding: 0px 0px
    .projectbox
      width: 100%
      margin-bottom: 60px
      img
        width: 95%
  .modal
    .content
      padding: 10px 10px
@media screen and (min-width: 900px)
  .introduction
    padding: 10px 100px 
    .name 
      font-size: 60px
  .section-content
    padding: 100px 100px
    .title
      width: 20%
    .content
      width: 80%
.modal
  z-index: 999
  .modal-card
    .modal-card-head
      background-color: #428bca
    .content
      h2
        font-weight: bold
        color: white
      p
        color: #eee
    border-radius: 5px
    .modal-card-body
      background-color: #fff
      h2
        color: #1C1C1C
      p
        display: inline
        color: #4a4a4a
body
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
  margin: 0
  overflow-x: hidden
.projectbox
  padding: 0 10px
  width: 45%
  float: left
  margin-bottom: 60px
  img
    width: 90%
    border: 1px solid #eee
    border-radius: 10px
    margin-bottom: 10px
    cursor: pointer
  .small
    color: #deeef5
  .project-title
    font-size: 20px
    color: white
    text-transform: none
    font-weight: bold
    margin: 5px 0 10px 0
  .project-subtitle
    font-size: 12px
    color: white
    text-transform: none
    font-weight: normal
    margin: 5px 0
.contact-icon
  font-size: 2.5em
  margin: 3px
  color: white
.home-section
  p
    color: #eee
    strong
      font-size: bold
      color: white
  display: table
  width: 100%
  height: 600px
  position: relative
  background: linear-gradient(to bottom, rgba(34,125,170,1) 0%, rgba(81,172,205,1) 100%)
  span
    display: inline
  h2
    color: white
    margin-bottom: 5px
  .introduction 
    vertical-align: middle
    display: table-cell
    .name
      font-weight: bold
      color: white
      margin: 0
    .introduce
      color: white
.profile-picture
  border-radius: 50px
.whitebg-section
  width: 100%
  display: block
  .title
    h1
      color: #3295be
      font-weight: bold
      &::after
        border: 2px solid #3295be
  .content
    h2
      color: #58798c
      font-weight: 800
    p
      color: #58798c
      font-size: 18px
    .projectbox
      .small
        color: #3295be
      .project-title
        color: #2473a0
      .tagg
        color: #aaa
.bluebg-section
  width: 100%
  background: linear-gradient(to bottom, rgba(34,125,170,1) 0%, rgba(81,172,205,1) 100%)
  .title
    h1
      color: white
      font-weight: bold
      &::after
        border: 2px solid white
  h2
    color: white
    text-transform: none
    font-weight: 800
  .box
    h2
      color: white
      font-weight: 800
    p
      color: #deeef5
      font-size: 18px
  .projectbox
    .small
      color: #deeef5
    .project-title
      color: white
    .project-subtitle
      color: white
.title
  float: left
  h1
    margin-top: 0px
    margin-bottom: 16px
    font-weight: bold
    &::after
      content: ' '
      display: block
      width: 50px
      margin: 10px 0
  img
    margin: 0 auto
.content
  float: left
  padding: 0px 50px
  display: block
  p
    margin: 0
    line-height: 30px
.section-content
  display: flex
.small
  font-size: 14px
  color: #aac7d9
  margin-bottom: 10px
.box
  background-color: transparent !important
  border: 1px solid #89bbd3
  border-radius: 10px
  padding: 20px
  color: white
  margin-bottom: 20px
  transition: all ease 0.5s
  h2
    display: inline
.tagg
  background-color: transparent
  border: 1px solid #ddd
  display: inline-block
  border-radius: 6px
  padding: 8px 10px
  font-size: 12px
  color: #deeef5
  margin-right: 5px
  margin-bottom: 10px
h1
  &::after
    content: ' '
    display: block
    width: 50px
    margin: 10px 0
    border: 2px solid #fff
</style>



// WEBPACK FOOTER //
// src/App.vue